import { ExternalJobs } from '@/components/ExternalJobs'
import Head from 'next/head'
import { useRouter } from 'next/router'
import React from 'react'

// const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL as string

// const { id } = params
// const response = await fetch(`${API_BASE_URL}/job/${id}`)
// const job = response.json()
// console.log({ job, id })
// return {
//   title: 'post?.title',
//   description: 'post?.description',
// }

// export const getStaticPaths = (async () => {
//   return {
//     paths: [
//       {
//         params: {
//           id: '02329a69285a40ceb6f8309b633a8c1f',
//         },
//       }, // See the "paths" section below
//     ],
//     fallback: false, // false or "blocking"
//   }
// })

// export const getStaticProps = (async ({params}: {params: {id:string}}) => {
//   console.log({  params, api: API_BASE_URL })
//   const res = await fetch(`${API_BASE_URL}/job/${params.id}`)
//   const job = await res.json()
//   return { props: { job } }
// })

// export const getStaticProps = async () => {
//   const res = await fetch(`${API_BASE_URL}/job/all-jobs`)
//   const jobs = await res.json()
//   console.log({jobs})
//   // Get the paths we want to prerender based on posts
//   // In production environments, prerender all pages
//   // (slower builds, but faster initial page load)
//   const paths = jobs.map((job) => ({
//     params: { id: job.id },
//   }))

//   // { fallback: false } means other routes should 404
//   return { paths, fallback: false }
// }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Index = (props: any) => {
  console.log({ props })
  const router = useRouter()
  const { id } = router.query
  const [openShareJob, setOpenShareJob] = React.useState(false)

  const jobTitleArr = String(id).split('-')
  jobTitleArr.pop()
  const jobTitle = jobTitleArr
    .map((word) => {
      const firstLetter = word[0].toUpperCase()
      const omitFirstLetter = word.slice(1, word.length + 1)

      return `${firstLetter}${omitFirstLetter}`
    })
    .join(' ')

  const metaTitle =
    jobTitle.length > 0
      ? `Scout4Job | ${jobTitle} Job`
      : `Scout4Job | Job detail`

  return (
    <>
      <Head>
        <title>{metaTitle}</title>

        <meta
          name="keywords"
          content="job openings, employment opportunities, career listings, job search, find jobs, job vacancies, hiring now, work opportunities, job applications, job board, job listings, job portal, jobs near me, job search engine, online job search, job posting site, job classifieds, job alerts, job seekers, job match, free job posting sites in nigeria, recruitment portals in nigeria, remote jobs, full-time jobs, interviews, job seeker tips, interview tips, job fair, resume builder, internship, entry-level jobs"
        />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaTitle} />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/scout4job/image/upload/v1696514292/uc_g0zqgl.png"
        />
        <meta property="og:url" content="https://scout4job.com" />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content={metaTitle} />
        <meta name="twitter:site" content="@scout4job" />
        <meta name="twitter:description" content={metaTitle} />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/scout4job/image/upload/v1696514292/uc_g0zqgl.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>
      <div className="w-full">
        <ExternalJobs
          jobId={id as string}
          openShareJob={openShareJob}
          setOpenShareJob={setOpenShareJob}
        />
      </div>
    </>
  )
}

export default Index
